/* tslint:disable */
/* eslint-disable */
/**
 * ELOfleet API Documentation
 * Backend of the ELOfleet fleet management system
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from '../runtime';
import {
    type ErrorResponse,
    ErrorResponseFromJSON,
    ErrorResponseToJSON,
} from '../models/ErrorResponse';
import {
    type FleetRole,
    FleetRoleFromJSON,
    FleetRoleToJSON,
} from '../models/FleetRole';
import {
    type LoggedInUserUpdate,
    LoggedInUserUpdateFromJSON,
    LoggedInUserUpdateToJSON,
} from '../models/LoggedInUserUpdate';
import {
    type PageInfo,
    PageInfoFromJSON,
    PageInfoToJSON,
} from '../models/PageInfo';
import {
    type RoleGroups,
    RoleGroupsFromJSON,
    RoleGroupsToJSON,
} from '../models/RoleGroups';
import {
    type SortDirection,
    SortDirectionFromJSON,
    SortDirectionToJSON,
} from '../models/SortDirection';
import {
    type User,
    UserFromJSON,
    UserToJSON,
} from '../models/User';
import {
    type UserCreate,
    UserCreateFromJSON,
    UserCreateToJSON,
} from '../models/UserCreate';
import {
    type UserDataExportRequest,
    UserDataExportRequestFromJSON,
    UserDataExportRequestToJSON,
} from '../models/UserDataExportRequest';
import {
    type UserDataExportResponse,
    UserDataExportResponseFromJSON,
    UserDataExportResponseToJSON,
} from '../models/UserDataExportResponse';
import {
    type UserSortKey,
    UserSortKeyFromJSON,
    UserSortKeyToJSON,
} from '../models/UserSortKey';
import {
    type UserUpdate,
    UserUpdateFromJSON,
    UserUpdateToJSON,
} from '../models/UserUpdate';

export interface UsersCreateUserRequest {
    userCreate: UserCreate;
}

export interface UsersDeleteUserRequest {
    userId: string;
}

export interface UsersExportUserListRequest {
    timezone: string;
    exportType: UsersExportUserListExportType;
    listType: UsersExportUserListListType;
    pageSize: number;
    search?: string | null;
    roleGroup?: RoleGroups;
    departmentIds?: Array<string> | null;
    fleetRoles?: Array<FleetRole> | null;
    userGroupIds?: Array<string> | null;
    shiftIds?: Array<string> | null;
    page?: number | null;
    sortDirection?: SortDirection;
    sortKey?: UserSortKey;
}

export interface UsersInitiateUserDataExportRequest {
    userId: string;
    userDataExportRequest: UserDataExportRequest;
}

export interface UsersListUsersRequest {
    pageSize: number;
    search?: string | null;
    roleGroup?: RoleGroups;
    departmentIds?: Array<string> | null;
    fleetRoles?: Array<FleetRole> | null;
    userGroupIds?: Array<string> | null;
    shiftIds?: Array<string> | null;
    page?: number | null;
    sortDirection?: SortDirection;
    sortKey?: UserSortKey;
}

export interface UsersListUsersMetadataRequest {
    pageSize: number;
    roleGroup?: RoleGroups;
    search?: string | null;
    departmentIds?: Array<string> | null;
    fleetRoles?: Array<FleetRole> | null;
    userGroupIds?: Array<string> | null;
    shiftIds?: Array<string> | null;
    page?: number | null;
    sortDirection?: SortDirection;
    sortKey?: UserSortKey;
}

export interface UsersReadDriverByVehicleAndTimeRequest {
    vehicleId: string;
    time: Date;
}

export interface UsersReadLastDriverByVehicleRequest {
    vehicleId: string;
}

export interface UsersReadUserRequest {
    userId: string;
}

export interface UsersUpdateLoggedInUserRequest {
    loggedInUserUpdate: LoggedInUserUpdate;
}

export interface UsersUpdateUserRequest {
    userId: string;
    userUpdate: UserUpdate;
}

export interface UsersValidateCreateUserRequest {
    userCreate: UserCreate;
}

export interface UsersValidateInitiateUserDataExportRequest {
    userId: string;
    userDataExportRequest: UserDataExportRequest;
}

export interface UsersValidateUpdateLoggedInUserRequest {
    loggedInUserUpdate: LoggedInUserUpdate;
}

export interface UsersValidateUpdateUserRequest {
    userId: string;
    userUpdate: UserUpdate;
}

/**
 * UsersApi - interface
 * 
 * @export
 * @interface UsersApiInterface
 */
export interface UsersApiInterface {
    /**
     * Creates request options for usersCreateUser without sending the request
     * @param {UserCreate} userCreate 
     * @throws {RequiredError}
     * @memberof UsersApiInterface
     */
    usersCreateUserRequestOpts(requestParameters: UsersCreateUserRequest): Promise<runtime.RequestOpts>;

    /**
     * Create a new user.
     * @summary Create a user
     * @param {UserCreate} userCreate 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApiInterface
     */
    usersCreateUserRaw(requestParameters: UsersCreateUserRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<User>>;

    /**
     * Create a new user.
     * Create a user
     */
    usersCreateUser(requestParameters: UsersCreateUserRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<User>;

    /**
     * Creates request options for usersDeleteUser without sending the request
     * @param {string} userId 
     * @throws {RequiredError}
     * @memberof UsersApiInterface
     */
    usersDeleteUserRequestOpts(requestParameters: UsersDeleteUserRequest): Promise<runtime.RequestOpts>;

    /**
     * Delete the user with the given ID.
     * @summary Delete a user
     * @param {string} userId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApiInterface
     */
    usersDeleteUserRaw(requestParameters: UsersDeleteUserRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     * Delete the user with the given ID.
     * Delete a user
     */
    usersDeleteUser(requestParameters: UsersDeleteUserRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * Creates request options for usersExportUserList without sending the request
     * @param {string} timezone 
     * @param {'csv' | 'xlsx'} exportType 
     * @param {'operators' | 'productivity'} listType 
     * @param {number} pageSize 
     * @param {string} [search] 
     * @param {RoleGroups} [roleGroup] 
     * @param {Array<string>} [departmentIds] 
     * @param {Array<FleetRole>} [fleetRoles] 
     * @param {Array<string>} [userGroupIds] 
     * @param {Array<string>} [shiftIds] 
     * @param {number} [page] 
     * @param {SortDirection} [sortDirection] 
     * @param {UserSortKey} [sortKey] 
     * @throws {RequiredError}
     * @memberof UsersApiInterface
     */
    usersExportUserListRequestOpts(requestParameters: UsersExportUserListRequest): Promise<runtime.RequestOpts>;

    /**
     * Exports all users with consideration of optional filters while distinguishing between different frontend pages.
     * @summary Export user list as csv or xlsx for a specific frontend page
     * @param {string} timezone 
     * @param {'csv' | 'xlsx'} exportType 
     * @param {'operators' | 'productivity'} listType 
     * @param {number} pageSize 
     * @param {string} [search] 
     * @param {RoleGroups} [roleGroup] 
     * @param {Array<string>} [departmentIds] 
     * @param {Array<FleetRole>} [fleetRoles] 
     * @param {Array<string>} [userGroupIds] 
     * @param {Array<string>} [shiftIds] 
     * @param {number} [page] 
     * @param {SortDirection} [sortDirection] 
     * @param {UserSortKey} [sortKey] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApiInterface
     */
    usersExportUserListRaw(requestParameters: UsersExportUserListRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<string>>;

    /**
     * Exports all users with consideration of optional filters while distinguishing between different frontend pages.
     * Export user list as csv or xlsx for a specific frontend page
     */
    usersExportUserList(requestParameters: UsersExportUserListRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<string>;

    /**
     * Creates request options for usersInitiateUserDataExport without sending the request
     * @param {string} userId 
     * @param {UserDataExportRequest} userDataExportRequest 
     * @throws {RequiredError}
     * @memberof UsersApiInterface
     */
    usersInitiateUserDataExportRequestOpts(requestParameters: UsersInitiateUserDataExportRequest): Promise<runtime.RequestOpts>;

    /**
     * Initiate a GDPR user data export to be generated and sent encrypted to the provided email.
     * @summary Initiate GDPR data export
     * @param {string} userId 
     * @param {UserDataExportRequest} userDataExportRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApiInterface
     */
    usersInitiateUserDataExportRaw(requestParameters: UsersInitiateUserDataExportRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<UserDataExportResponse>>;

    /**
     * Initiate a GDPR user data export to be generated and sent encrypted to the provided email.
     * Initiate GDPR data export
     */
    usersInitiateUserDataExport(requestParameters: UsersInitiateUserDataExportRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<UserDataExportResponse>;

    /**
     * Creates request options for usersListUsers without sending the request
     * @param {number} pageSize 
     * @param {string} [search] 
     * @param {RoleGroups} [roleGroup] 
     * @param {Array<string>} [departmentIds] 
     * @param {Array<FleetRole>} [fleetRoles] 
     * @param {Array<string>} [userGroupIds] 
     * @param {Array<string>} [shiftIds] 
     * @param {number} [page] 
     * @param {SortDirection} [sortDirection] 
     * @param {UserSortKey} [sortKey] 
     * @throws {RequiredError}
     * @memberof UsersApiInterface
     */
    usersListUsersRequestOpts(requestParameters: UsersListUsersRequest): Promise<runtime.RequestOpts>;

    /**
     * Lists all the users present. If `search` is specified, return values similar to the `email`, `firstName` and `lastName` fields, and `sortKey` will not have any effect: results will be sorted by similarity to the search term instead. If `role_group` is specified, return Management Users or Fleet Users
     * @summary List users
     * @param {number} pageSize 
     * @param {string} [search] 
     * @param {RoleGroups} [roleGroup] 
     * @param {Array<string>} [departmentIds] 
     * @param {Array<FleetRole>} [fleetRoles] 
     * @param {Array<string>} [userGroupIds] 
     * @param {Array<string>} [shiftIds] 
     * @param {number} [page] 
     * @param {SortDirection} [sortDirection] 
     * @param {UserSortKey} [sortKey] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApiInterface
     */
    usersListUsersRaw(requestParameters: UsersListUsersRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<User>>>;

    /**
     * Lists all the users present. If `search` is specified, return values similar to the `email`, `firstName` and `lastName` fields, and `sortKey` will not have any effect: results will be sorted by similarity to the search term instead. If `role_group` is specified, return Management Users or Fleet Users
     * List users
     */
    usersListUsers(requestParameters: UsersListUsersRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<User>>;

    /**
     * Creates request options for usersListUsersMetadata without sending the request
     * @param {number} pageSize 
     * @param {RoleGroups} [roleGroup] 
     * @param {string} [search] 
     * @param {Array<string>} [departmentIds] 
     * @param {Array<FleetRole>} [fleetRoles] 
     * @param {Array<string>} [userGroupIds] 
     * @param {Array<string>} [shiftIds] 
     * @param {number} [page] 
     * @param {SortDirection} [sortDirection] 
     * @param {UserSortKey} [sortKey] 
     * @throws {RequiredError}
     * @memberof UsersApiInterface
     */
    usersListUsersMetadataRequestOpts(requestParameters: UsersListUsersMetadataRequest): Promise<runtime.RequestOpts>;

    /**
     * Fetch information about the total amount of pages available.
     * @summary User listing metadata
     * @param {number} pageSize 
     * @param {RoleGroups} [roleGroup] 
     * @param {string} [search] 
     * @param {Array<string>} [departmentIds] 
     * @param {Array<FleetRole>} [fleetRoles] 
     * @param {Array<string>} [userGroupIds] 
     * @param {Array<string>} [shiftIds] 
     * @param {number} [page] 
     * @param {SortDirection} [sortDirection] 
     * @param {UserSortKey} [sortKey] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApiInterface
     */
    usersListUsersMetadataRaw(requestParameters: UsersListUsersMetadataRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PageInfo>>;

    /**
     * Fetch information about the total amount of pages available.
     * User listing metadata
     */
    usersListUsersMetadata(requestParameters: UsersListUsersMetadataRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PageInfo>;

    /**
     * Creates request options for usersReadDriverByVehicleAndTime without sending the request
     * @param {string} vehicleId 
     * @param {Date} time 
     * @throws {RequiredError}
     * @memberof UsersApiInterface
     */
    usersReadDriverByVehicleAndTimeRequestOpts(requestParameters: UsersReadDriverByVehicleAndTimeRequest): Promise<runtime.RequestOpts>;

    /**
     * Returns the driver specified by the given vehicle and time.
     * @summary Get a single user
     * @param {string} vehicleId 
     * @param {Date} time 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApiInterface
     */
    usersReadDriverByVehicleAndTimeRaw(requestParameters: UsersReadDriverByVehicleAndTimeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<User>>;

    /**
     * Returns the driver specified by the given vehicle and time.
     * Get a single user
     */
    usersReadDriverByVehicleAndTime(requestParameters: UsersReadDriverByVehicleAndTimeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<User>;

    /**
     * Creates request options for usersReadLastDriverByVehicle without sending the request
     * @param {string} vehicleId 
     * @throws {RequiredError}
     * @memberof UsersApiInterface
     */
    usersReadLastDriverByVehicleRequestOpts(requestParameters: UsersReadLastDriverByVehicleRequest): Promise<runtime.RequestOpts>;

    /**
     * Returns the last driver specified by the given vehicle.
     * @summary Get a single user
     * @param {string} vehicleId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApiInterface
     */
    usersReadLastDriverByVehicleRaw(requestParameters: UsersReadLastDriverByVehicleRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<User>>;

    /**
     * Returns the last driver specified by the given vehicle.
     * Get a single user
     */
    usersReadLastDriverByVehicle(requestParameters: UsersReadLastDriverByVehicleRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<User>;

    /**
     * Creates request options for usersReadUser without sending the request
     * @param {string} userId 
     * @throws {RequiredError}
     * @memberof UsersApiInterface
     */
    usersReadUserRequestOpts(requestParameters: UsersReadUserRequest): Promise<runtime.RequestOpts>;

    /**
     * Returns the user specified by the given ID.
     * @summary Get a single user
     * @param {string} userId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApiInterface
     */
    usersReadUserRaw(requestParameters: UsersReadUserRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<User>>;

    /**
     * Returns the user specified by the given ID.
     * Get a single user
     */
    usersReadUser(requestParameters: UsersReadUserRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<User>;

    /**
     * Creates request options for usersUpdateLoggedInUser without sending the request
     * @param {LoggedInUserUpdate} loggedInUserUpdate 
     * @throws {RequiredError}
     * @memberof UsersApiInterface
     */
    usersUpdateLoggedInUserRequestOpts(requestParameters: UsersUpdateLoggedInUserRequest): Promise<runtime.RequestOpts>;

    /**
     * Update the user that\'s currently logged.
     * @summary Update the logged in user
     * @param {LoggedInUserUpdate} loggedInUserUpdate 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApiInterface
     */
    usersUpdateLoggedInUserRaw(requestParameters: UsersUpdateLoggedInUserRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<User>>;

    /**
     * Update the user that\'s currently logged.
     * Update the logged in user
     */
    usersUpdateLoggedInUser(requestParameters: UsersUpdateLoggedInUserRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<User>;

    /**
     * Creates request options for usersUpdateUser without sending the request
     * @param {string} userId 
     * @param {UserUpdate} userUpdate 
     * @throws {RequiredError}
     * @memberof UsersApiInterface
     */
    usersUpdateUserRequestOpts(requestParameters: UsersUpdateUserRequest): Promise<runtime.RequestOpts>;

    /**
     * Update the user specified by the given ID.
     * @summary Update user
     * @param {string} userId 
     * @param {UserUpdate} userUpdate 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApiInterface
     */
    usersUpdateUserRaw(requestParameters: UsersUpdateUserRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<User>>;

    /**
     * Update the user specified by the given ID.
     * Update user
     */
    usersUpdateUser(requestParameters: UsersUpdateUserRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<User>;

    /**
     * Creates request options for usersValidateCreateUser without sending the request
     * @param {UserCreate} userCreate 
     * @throws {RequiredError}
     * @memberof UsersApiInterface
     */
    usersValidateCreateUserRequestOpts(requestParameters: UsersValidateCreateUserRequest): Promise<runtime.RequestOpts>;

    /**
     * Validate data for a new user without persisting it. Return an empty body if the data is valid. Return validation errors if it is invalid.
     * @summary Validate a new user
     * @param {UserCreate} userCreate 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApiInterface
     */
    usersValidateCreateUserRaw(requestParameters: UsersValidateCreateUserRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     * Validate data for a new user without persisting it. Return an empty body if the data is valid. Return validation errors if it is invalid.
     * Validate a new user
     */
    usersValidateCreateUser(requestParameters: UsersValidateCreateUserRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * Creates request options for usersValidateInitiateUserDataExport without sending the request
     * @param {string} userId 
     * @param {UserDataExportRequest} userDataExportRequest 
     * @throws {RequiredError}
     * @memberof UsersApiInterface
     */
    usersValidateInitiateUserDataExportRequestOpts(requestParameters: UsersValidateInitiateUserDataExportRequest): Promise<runtime.RequestOpts>;

    /**
     * Validate data for initiating a GDPR user data export. Return an empty body if the data is valid. Return validation errors if it is invalid.
     * @summary Validate GDPR data export
     * @param {string} userId 
     * @param {UserDataExportRequest} userDataExportRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApiInterface
     */
    usersValidateInitiateUserDataExportRaw(requestParameters: UsersValidateInitiateUserDataExportRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     * Validate data for initiating a GDPR user data export. Return an empty body if the data is valid. Return validation errors if it is invalid.
     * Validate GDPR data export
     */
    usersValidateInitiateUserDataExport(requestParameters: UsersValidateInitiateUserDataExportRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * Creates request options for usersValidateUpdateLoggedInUser without sending the request
     * @param {LoggedInUserUpdate} loggedInUserUpdate 
     * @throws {RequiredError}
     * @memberof UsersApiInterface
     */
    usersValidateUpdateLoggedInUserRequestOpts(requestParameters: UsersValidateUpdateLoggedInUserRequest): Promise<runtime.RequestOpts>;

    /**
     * Validate the update of the user that\'s currently logged.
     * @summary Validate the update of an logged in user
     * @param {LoggedInUserUpdate} loggedInUserUpdate 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApiInterface
     */
    usersValidateUpdateLoggedInUserRaw(requestParameters: UsersValidateUpdateLoggedInUserRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     * Validate the update of the user that\'s currently logged.
     * Validate the update of an logged in user
     */
    usersValidateUpdateLoggedInUser(requestParameters: UsersValidateUpdateLoggedInUserRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * Creates request options for usersValidateUpdateUser without sending the request
     * @param {string} userId 
     * @param {UserUpdate} userUpdate 
     * @throws {RequiredError}
     * @memberof UsersApiInterface
     */
    usersValidateUpdateUserRequestOpts(requestParameters: UsersValidateUpdateUserRequest): Promise<runtime.RequestOpts>;

    /**
     * Validate data for updating the given user, without persisting it. Return an empty body if the data is valid. Return validation errors if it is invalid.
     * @summary Validate user update
     * @param {string} userId 
     * @param {UserUpdate} userUpdate 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApiInterface
     */
    usersValidateUpdateUserRaw(requestParameters: UsersValidateUpdateUserRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     * Validate data for updating the given user, without persisting it. Return an empty body if the data is valid. Return validation errors if it is invalid.
     * Validate user update
     */
    usersValidateUpdateUser(requestParameters: UsersValidateUpdateUserRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

}

/**
 * 
 */
export class UsersApi extends runtime.BaseAPI implements UsersApiInterface {

    /**
     * Creates request options for usersCreateUser without sending the request
     */
    async usersCreateUserRequestOpts(requestParameters: UsersCreateUserRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['userCreate'] == null) {
            throw new runtime.RequiredError(
                'userCreate',
                'Required parameter "userCreate" was null or undefined when calling usersCreateUser().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("HttpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/users/`;

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: UserCreateToJSON(requestParameters['userCreate']),
        };
    }

    /**
     * Create a new user.
     * Create a user
     */
    async usersCreateUserRaw(requestParameters: UsersCreateUserRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<User>> {
        const requestOptions = await this.usersCreateUserRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => UserFromJSON(jsonValue));
    }

    /**
     * Create a new user.
     * Create a user
     */
    async usersCreateUser(requestParameters: UsersCreateUserRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<User> {
        const response = await this.usersCreateUserRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for usersDeleteUser without sending the request
     */
    async usersDeleteUserRequestOpts(requestParameters: UsersDeleteUserRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['userId'] == null) {
            throw new runtime.RequiredError(
                'userId',
                'Required parameter "userId" was null or undefined when calling usersDeleteUser().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("HttpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/users/{user_id}`;
        urlPath = urlPath.replace('{user_id}', encodeURIComponent(String(requestParameters['userId'])));

        return {
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Delete the user with the given ID.
     * Delete a user
     */
    async usersDeleteUserRaw(requestParameters: UsersDeleteUserRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const requestOptions = await this.usersDeleteUserRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Delete the user with the given ID.
     * Delete a user
     */
    async usersDeleteUser(requestParameters: UsersDeleteUserRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.usersDeleteUserRaw(requestParameters, initOverrides);
    }

    /**
     * Creates request options for usersExportUserList without sending the request
     */
    async usersExportUserListRequestOpts(requestParameters: UsersExportUserListRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['timezone'] == null) {
            throw new runtime.RequiredError(
                'timezone',
                'Required parameter "timezone" was null or undefined when calling usersExportUserList().'
            );
        }

        if (requestParameters['exportType'] == null) {
            throw new runtime.RequiredError(
                'exportType',
                'Required parameter "exportType" was null or undefined when calling usersExportUserList().'
            );
        }

        if (requestParameters['listType'] == null) {
            throw new runtime.RequiredError(
                'listType',
                'Required parameter "listType" was null or undefined when calling usersExportUserList().'
            );
        }

        if (requestParameters['pageSize'] == null) {
            throw new runtime.RequiredError(
                'pageSize',
                'Required parameter "pageSize" was null or undefined when calling usersExportUserList().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['search'] != null) {
            queryParameters['search'] = requestParameters['search'];
        }

        if (requestParameters['roleGroup'] != null) {
            queryParameters['role_group'] = requestParameters['roleGroup'];
        }

        if (requestParameters['timezone'] != null) {
            queryParameters['timezone'] = requestParameters['timezone'];
        }

        if (requestParameters['exportType'] != null) {
            queryParameters['export_type'] = requestParameters['exportType'];
        }

        if (requestParameters['listType'] != null) {
            queryParameters['list_type'] = requestParameters['listType'];
        }

        if (requestParameters['departmentIds'] != null) {
            queryParameters['department_ids'] = requestParameters['departmentIds'];
        }

        if (requestParameters['fleetRoles'] != null) {
            queryParameters['fleet_roles'] = requestParameters['fleetRoles'];
        }

        if (requestParameters['userGroupIds'] != null) {
            queryParameters['user_group_ids'] = requestParameters['userGroupIds'];
        }

        if (requestParameters['shiftIds'] != null) {
            queryParameters['shift_ids'] = requestParameters['shiftIds'];
        }

        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }

        if (requestParameters['pageSize'] != null) {
            queryParameters['page_size'] = requestParameters['pageSize'];
        }

        if (requestParameters['sortDirection'] != null) {
            queryParameters['sort_direction'] = requestParameters['sortDirection'];
        }

        if (requestParameters['sortKey'] != null) {
            queryParameters['sort_key'] = requestParameters['sortKey'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("HttpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/users/export`;

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Exports all users with consideration of optional filters while distinguishing between different frontend pages.
     * Export user list as csv or xlsx for a specific frontend page
     */
    async usersExportUserListRaw(requestParameters: UsersExportUserListRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<string>> {
        const requestOptions = await this.usersExportUserListRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<string>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     * Exports all users with consideration of optional filters while distinguishing between different frontend pages.
     * Export user list as csv or xlsx for a specific frontend page
     */
    async usersExportUserList(requestParameters: UsersExportUserListRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<string> {
        const response = await this.usersExportUserListRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for usersInitiateUserDataExport without sending the request
     */
    async usersInitiateUserDataExportRequestOpts(requestParameters: UsersInitiateUserDataExportRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['userId'] == null) {
            throw new runtime.RequiredError(
                'userId',
                'Required parameter "userId" was null or undefined when calling usersInitiateUserDataExport().'
            );
        }

        if (requestParameters['userDataExportRequest'] == null) {
            throw new runtime.RequiredError(
                'userDataExportRequest',
                'Required parameter "userDataExportRequest" was null or undefined when calling usersInitiateUserDataExport().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("HttpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/users/{user_id}/export`;
        urlPath = urlPath.replace('{user_id}', encodeURIComponent(String(requestParameters['userId'])));

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: UserDataExportRequestToJSON(requestParameters['userDataExportRequest']),
        };
    }

    /**
     * Initiate a GDPR user data export to be generated and sent encrypted to the provided email.
     * Initiate GDPR data export
     */
    async usersInitiateUserDataExportRaw(requestParameters: UsersInitiateUserDataExportRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<UserDataExportResponse>> {
        const requestOptions = await this.usersInitiateUserDataExportRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => UserDataExportResponseFromJSON(jsonValue));
    }

    /**
     * Initiate a GDPR user data export to be generated and sent encrypted to the provided email.
     * Initiate GDPR data export
     */
    async usersInitiateUserDataExport(requestParameters: UsersInitiateUserDataExportRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<UserDataExportResponse> {
        const response = await this.usersInitiateUserDataExportRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for usersListUsers without sending the request
     */
    async usersListUsersRequestOpts(requestParameters: UsersListUsersRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['pageSize'] == null) {
            throw new runtime.RequiredError(
                'pageSize',
                'Required parameter "pageSize" was null or undefined when calling usersListUsers().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['search'] != null) {
            queryParameters['search'] = requestParameters['search'];
        }

        if (requestParameters['roleGroup'] != null) {
            queryParameters['role_group'] = requestParameters['roleGroup'];
        }

        if (requestParameters['departmentIds'] != null) {
            queryParameters['department_ids'] = requestParameters['departmentIds'];
        }

        if (requestParameters['fleetRoles'] != null) {
            queryParameters['fleet_roles'] = requestParameters['fleetRoles'];
        }

        if (requestParameters['userGroupIds'] != null) {
            queryParameters['user_group_ids'] = requestParameters['userGroupIds'];
        }

        if (requestParameters['shiftIds'] != null) {
            queryParameters['shift_ids'] = requestParameters['shiftIds'];
        }

        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }

        if (requestParameters['pageSize'] != null) {
            queryParameters['page_size'] = requestParameters['pageSize'];
        }

        if (requestParameters['sortDirection'] != null) {
            queryParameters['sort_direction'] = requestParameters['sortDirection'];
        }

        if (requestParameters['sortKey'] != null) {
            queryParameters['sort_key'] = requestParameters['sortKey'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("HttpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/users/`;

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Lists all the users present. If `search` is specified, return values similar to the `email`, `firstName` and `lastName` fields, and `sortKey` will not have any effect: results will be sorted by similarity to the search term instead. If `role_group` is specified, return Management Users or Fleet Users
     * List users
     */
    async usersListUsersRaw(requestParameters: UsersListUsersRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<User>>> {
        const requestOptions = await this.usersListUsersRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(UserFromJSON));
    }

    /**
     * Lists all the users present. If `search` is specified, return values similar to the `email`, `firstName` and `lastName` fields, and `sortKey` will not have any effect: results will be sorted by similarity to the search term instead. If `role_group` is specified, return Management Users or Fleet Users
     * List users
     */
    async usersListUsers(requestParameters: UsersListUsersRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<User>> {
        const response = await this.usersListUsersRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for usersListUsersMetadata without sending the request
     */
    async usersListUsersMetadataRequestOpts(requestParameters: UsersListUsersMetadataRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['pageSize'] == null) {
            throw new runtime.RequiredError(
                'pageSize',
                'Required parameter "pageSize" was null or undefined when calling usersListUsersMetadata().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['roleGroup'] != null) {
            queryParameters['role_group'] = requestParameters['roleGroup'];
        }

        if (requestParameters['search'] != null) {
            queryParameters['search'] = requestParameters['search'];
        }

        if (requestParameters['departmentIds'] != null) {
            queryParameters['department_ids'] = requestParameters['departmentIds'];
        }

        if (requestParameters['fleetRoles'] != null) {
            queryParameters['fleet_roles'] = requestParameters['fleetRoles'];
        }

        if (requestParameters['userGroupIds'] != null) {
            queryParameters['user_group_ids'] = requestParameters['userGroupIds'];
        }

        if (requestParameters['shiftIds'] != null) {
            queryParameters['shift_ids'] = requestParameters['shiftIds'];
        }

        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }

        if (requestParameters['pageSize'] != null) {
            queryParameters['page_size'] = requestParameters['pageSize'];
        }

        if (requestParameters['sortDirection'] != null) {
            queryParameters['sort_direction'] = requestParameters['sortDirection'];
        }

        if (requestParameters['sortKey'] != null) {
            queryParameters['sort_key'] = requestParameters['sortKey'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("HttpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/users/meta`;

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Fetch information about the total amount of pages available.
     * User listing metadata
     */
    async usersListUsersMetadataRaw(requestParameters: UsersListUsersMetadataRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PageInfo>> {
        const requestOptions = await this.usersListUsersMetadataRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PageInfoFromJSON(jsonValue));
    }

    /**
     * Fetch information about the total amount of pages available.
     * User listing metadata
     */
    async usersListUsersMetadata(requestParameters: UsersListUsersMetadataRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PageInfo> {
        const response = await this.usersListUsersMetadataRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for usersReadDriverByVehicleAndTime without sending the request
     */
    async usersReadDriverByVehicleAndTimeRequestOpts(requestParameters: UsersReadDriverByVehicleAndTimeRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['vehicleId'] == null) {
            throw new runtime.RequiredError(
                'vehicleId',
                'Required parameter "vehicleId" was null or undefined when calling usersReadDriverByVehicleAndTime().'
            );
        }

        if (requestParameters['time'] == null) {
            throw new runtime.RequiredError(
                'time',
                'Required parameter "time" was null or undefined when calling usersReadDriverByVehicleAndTime().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['vehicleId'] != null) {
            queryParameters['vehicle_id'] = requestParameters['vehicleId'];
        }

        if (requestParameters['time'] != null) {
            queryParameters['time'] = (requestParameters['time'] as any).toISOString();
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("HttpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/users/driver`;

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Returns the driver specified by the given vehicle and time.
     * Get a single user
     */
    async usersReadDriverByVehicleAndTimeRaw(requestParameters: UsersReadDriverByVehicleAndTimeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<User>> {
        const requestOptions = await this.usersReadDriverByVehicleAndTimeRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => UserFromJSON(jsonValue));
    }

    /**
     * Returns the driver specified by the given vehicle and time.
     * Get a single user
     */
    async usersReadDriverByVehicleAndTime(requestParameters: UsersReadDriverByVehicleAndTimeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<User> {
        const response = await this.usersReadDriverByVehicleAndTimeRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for usersReadLastDriverByVehicle without sending the request
     */
    async usersReadLastDriverByVehicleRequestOpts(requestParameters: UsersReadLastDriverByVehicleRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['vehicleId'] == null) {
            throw new runtime.RequiredError(
                'vehicleId',
                'Required parameter "vehicleId" was null or undefined when calling usersReadLastDriverByVehicle().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("HttpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/users/last_driver/{vehicle_id}`;
        urlPath = urlPath.replace('{vehicle_id}', encodeURIComponent(String(requestParameters['vehicleId'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Returns the last driver specified by the given vehicle.
     * Get a single user
     */
    async usersReadLastDriverByVehicleRaw(requestParameters: UsersReadLastDriverByVehicleRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<User>> {
        const requestOptions = await this.usersReadLastDriverByVehicleRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => UserFromJSON(jsonValue));
    }

    /**
     * Returns the last driver specified by the given vehicle.
     * Get a single user
     */
    async usersReadLastDriverByVehicle(requestParameters: UsersReadLastDriverByVehicleRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<User> {
        const response = await this.usersReadLastDriverByVehicleRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for usersReadUser without sending the request
     */
    async usersReadUserRequestOpts(requestParameters: UsersReadUserRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['userId'] == null) {
            throw new runtime.RequiredError(
                'userId',
                'Required parameter "userId" was null or undefined when calling usersReadUser().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("HttpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/users/{user_id}`;
        urlPath = urlPath.replace('{user_id}', encodeURIComponent(String(requestParameters['userId'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Returns the user specified by the given ID.
     * Get a single user
     */
    async usersReadUserRaw(requestParameters: UsersReadUserRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<User>> {
        const requestOptions = await this.usersReadUserRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => UserFromJSON(jsonValue));
    }

    /**
     * Returns the user specified by the given ID.
     * Get a single user
     */
    async usersReadUser(requestParameters: UsersReadUserRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<User> {
        const response = await this.usersReadUserRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for usersUpdateLoggedInUser without sending the request
     */
    async usersUpdateLoggedInUserRequestOpts(requestParameters: UsersUpdateLoggedInUserRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['loggedInUserUpdate'] == null) {
            throw new runtime.RequiredError(
                'loggedInUserUpdate',
                'Required parameter "loggedInUserUpdate" was null or undefined when calling usersUpdateLoggedInUser().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("HttpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/users/`;

        return {
            path: urlPath,
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: LoggedInUserUpdateToJSON(requestParameters['loggedInUserUpdate']),
        };
    }

    /**
     * Update the user that\'s currently logged.
     * Update the logged in user
     */
    async usersUpdateLoggedInUserRaw(requestParameters: UsersUpdateLoggedInUserRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<User>> {
        const requestOptions = await this.usersUpdateLoggedInUserRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => UserFromJSON(jsonValue));
    }

    /**
     * Update the user that\'s currently logged.
     * Update the logged in user
     */
    async usersUpdateLoggedInUser(requestParameters: UsersUpdateLoggedInUserRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<User> {
        const response = await this.usersUpdateLoggedInUserRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for usersUpdateUser without sending the request
     */
    async usersUpdateUserRequestOpts(requestParameters: UsersUpdateUserRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['userId'] == null) {
            throw new runtime.RequiredError(
                'userId',
                'Required parameter "userId" was null or undefined when calling usersUpdateUser().'
            );
        }

        if (requestParameters['userUpdate'] == null) {
            throw new runtime.RequiredError(
                'userUpdate',
                'Required parameter "userUpdate" was null or undefined when calling usersUpdateUser().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("HttpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/users/{user_id}`;
        urlPath = urlPath.replace('{user_id}', encodeURIComponent(String(requestParameters['userId'])));

        return {
            path: urlPath,
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: UserUpdateToJSON(requestParameters['userUpdate']),
        };
    }

    /**
     * Update the user specified by the given ID.
     * Update user
     */
    async usersUpdateUserRaw(requestParameters: UsersUpdateUserRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<User>> {
        const requestOptions = await this.usersUpdateUserRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => UserFromJSON(jsonValue));
    }

    /**
     * Update the user specified by the given ID.
     * Update user
     */
    async usersUpdateUser(requestParameters: UsersUpdateUserRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<User> {
        const response = await this.usersUpdateUserRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for usersValidateCreateUser without sending the request
     */
    async usersValidateCreateUserRequestOpts(requestParameters: UsersValidateCreateUserRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['userCreate'] == null) {
            throw new runtime.RequiredError(
                'userCreate',
                'Required parameter "userCreate" was null or undefined when calling usersValidateCreateUser().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("HttpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/users/validate`;

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: UserCreateToJSON(requestParameters['userCreate']),
        };
    }

    /**
     * Validate data for a new user without persisting it. Return an empty body if the data is valid. Return validation errors if it is invalid.
     * Validate a new user
     */
    async usersValidateCreateUserRaw(requestParameters: UsersValidateCreateUserRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const requestOptions = await this.usersValidateCreateUserRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Validate data for a new user without persisting it. Return an empty body if the data is valid. Return validation errors if it is invalid.
     * Validate a new user
     */
    async usersValidateCreateUser(requestParameters: UsersValidateCreateUserRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.usersValidateCreateUserRaw(requestParameters, initOverrides);
    }

    /**
     * Creates request options for usersValidateInitiateUserDataExport without sending the request
     */
    async usersValidateInitiateUserDataExportRequestOpts(requestParameters: UsersValidateInitiateUserDataExportRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['userId'] == null) {
            throw new runtime.RequiredError(
                'userId',
                'Required parameter "userId" was null or undefined when calling usersValidateInitiateUserDataExport().'
            );
        }

        if (requestParameters['userDataExportRequest'] == null) {
            throw new runtime.RequiredError(
                'userDataExportRequest',
                'Required parameter "userDataExportRequest" was null or undefined when calling usersValidateInitiateUserDataExport().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("HttpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/users/{user_id}/export/validate`;
        urlPath = urlPath.replace('{user_id}', encodeURIComponent(String(requestParameters['userId'])));

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: UserDataExportRequestToJSON(requestParameters['userDataExportRequest']),
        };
    }

    /**
     * Validate data for initiating a GDPR user data export. Return an empty body if the data is valid. Return validation errors if it is invalid.
     * Validate GDPR data export
     */
    async usersValidateInitiateUserDataExportRaw(requestParameters: UsersValidateInitiateUserDataExportRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const requestOptions = await this.usersValidateInitiateUserDataExportRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Validate data for initiating a GDPR user data export. Return an empty body if the data is valid. Return validation errors if it is invalid.
     * Validate GDPR data export
     */
    async usersValidateInitiateUserDataExport(requestParameters: UsersValidateInitiateUserDataExportRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.usersValidateInitiateUserDataExportRaw(requestParameters, initOverrides);
    }

    /**
     * Creates request options for usersValidateUpdateLoggedInUser without sending the request
     */
    async usersValidateUpdateLoggedInUserRequestOpts(requestParameters: UsersValidateUpdateLoggedInUserRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['loggedInUserUpdate'] == null) {
            throw new runtime.RequiredError(
                'loggedInUserUpdate',
                'Required parameter "loggedInUserUpdate" was null or undefined when calling usersValidateUpdateLoggedInUser().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("HttpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/users/validate`;

        return {
            path: urlPath,
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: LoggedInUserUpdateToJSON(requestParameters['loggedInUserUpdate']),
        };
    }

    /**
     * Validate the update of the user that\'s currently logged.
     * Validate the update of an logged in user
     */
    async usersValidateUpdateLoggedInUserRaw(requestParameters: UsersValidateUpdateLoggedInUserRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const requestOptions = await this.usersValidateUpdateLoggedInUserRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Validate the update of the user that\'s currently logged.
     * Validate the update of an logged in user
     */
    async usersValidateUpdateLoggedInUser(requestParameters: UsersValidateUpdateLoggedInUserRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.usersValidateUpdateLoggedInUserRaw(requestParameters, initOverrides);
    }

    /**
     * Creates request options for usersValidateUpdateUser without sending the request
     */
    async usersValidateUpdateUserRequestOpts(requestParameters: UsersValidateUpdateUserRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['userId'] == null) {
            throw new runtime.RequiredError(
                'userId',
                'Required parameter "userId" was null or undefined when calling usersValidateUpdateUser().'
            );
        }

        if (requestParameters['userUpdate'] == null) {
            throw new runtime.RequiredError(
                'userUpdate',
                'Required parameter "userUpdate" was null or undefined when calling usersValidateUpdateUser().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("HttpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/users/{user_id}/validate`;
        urlPath = urlPath.replace('{user_id}', encodeURIComponent(String(requestParameters['userId'])));

        return {
            path: urlPath,
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: UserUpdateToJSON(requestParameters['userUpdate']),
        };
    }

    /**
     * Validate data for updating the given user, without persisting it. Return an empty body if the data is valid. Return validation errors if it is invalid.
     * Validate user update
     */
    async usersValidateUpdateUserRaw(requestParameters: UsersValidateUpdateUserRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const requestOptions = await this.usersValidateUpdateUserRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Validate data for updating the given user, without persisting it. Return an empty body if the data is valid. Return validation errors if it is invalid.
     * Validate user update
     */
    async usersValidateUpdateUser(requestParameters: UsersValidateUpdateUserRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.usersValidateUpdateUserRaw(requestParameters, initOverrides);
    }

}

/**
  * @export
  * @enum {string}
  */
export enum UsersExportUserListExportType {
    CSV = 'csv',
    XLSX = 'xlsx'
}
/**
  * @export
  * @enum {string}
  */
export enum UsersExportUserListListType {
    OPERATORS = 'operators',
    PRODUCTIVITY = 'productivity'
}
